import React, { useState } from 'react';
import { Mail } from 'lucide-react';

const UnSubscribeLandingPage = () => { 
  const [loading, setLoading] = useState(false); 
  const [error, setError] = useState(null); 

  const queryParams = new URLSearchParams(window.location.search);
  const EId = queryParams.get('EId'); 
  // const BUId = sessionStorage.getItem('BUId');
  const apiUrl = process.env.REACT_APP_API_URL;


  const handleUnsubscribe = async () => {
    // if (!EId) {
    //   alert("Email is missing.");
    //   return;
    // }

    setLoading(true);
    setError(null); 
console.log(EId);
    try {
     // const response = await fetch(`${apiUrl}/Mailer/UnSubscribeMail?MailId=${EId}`);
      const response = await fetch(`${apiUrl}/Mailer/UnSubscribeMail?MailId=${EId}`, {
        method: 'PATCH', // Or 'PUT', depending on your API
        headers: {
          'Content-Type': 'application/json',
        },
       // body: JSON.stringify({ MailLogId }),
      });

      // if (!response.ok) {
      //   throw new Error('Failed to unsubscribe. Please try again.');
      // }
      
      // If successful, handle the success response (optional)
      console.log(response)
      const data = await response.json();
      console.log(data)
      //alert('Successfully unsubscribed!');
      // Optionally close the window after success
      window.close();
    } catch (error) {
      // If there's an error during the API call
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    window.close();
  };

  return (
    <div className="min-h-screen bg-purple-200 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        {/* Icon */}
        <div className="mx-auto bg-gray-100 rounded-full p-4 w-20 h-20 flex items-center justify-center mb-6">
          <Mail className="w-10 h-10 text-purple-600" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          You're Unsubscribed
        </h1>

        {/* Messages */}
        <p className="text-gray-600 mb-2">
          We're so sorry to lose you, but we totally understand.
        </p>
        <p className="text-gray-600 mb-6">
          Did you unsubscribe by mistake? Don't worry! You can resubscribe instantly
          by clicking the button below.
        </p>

        {/* Error message */}
        {error && (
          <p className="text-red-500 mb-4">
            Error: {error}
          </p>
        )}

        {/* Form */}
        <div className="flex gap-4 mb-8 justify-center">
          <button
            id="btnUnSubscribe"
            onClick={handleUnsubscribe}
            className="flex-1 max-w-[200px] bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 transition-colors"
            disabled={loading} // Disable the button while loading
          >
            {loading ? 'Unsubscribing...' : 'Unsubscribe'}
          </button>
          <button
            id="btnCancel"
            onClick={handleCancel}
            className="flex-1 max-w-[200px] bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 transition-colors"
          >
            Oops, I want back in!
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnSubscribeLandingPage;
